module.exports = __webpack_public_path__ + "static/media/08.4eff10f1.webp";